function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMuteAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42 32c3.31 0 6 2.69 6 6 0 2.54-1.58 4.71-3.81 5.58l-7.77-7.77A5.999 5.999 0 0 1 42 32Zm-18-9c-.13 0-.25.01-.37.02l9.35 9.35c0-.12.02-.25.02-.37a9 9 0 0 0-9-9Zm24.61 25 4.29 4.29C57.21 49 60 43.82 60 38c0-9.93-8.08-18-18-18-2.59 0-5.04.56-7.27 1.55a15.14 15.14 0 0 1 3.29 5.13c.08-.03.16-.05.23-.07l.4-.12c.23-.07.45-.12.68-.18l.4-.09c.25-.05.5-.08.76-.12.12-.02.24-.03.36-.05.38-.04.75-.06 1.14-.06 6.62 0 12 5.38 12 12 0 4.17-2.15 7.85-5.39 10ZM42 8c-8.63 0-16.42 3.67-21.9 9.52 1.24-.34 2.55-.52 3.9-.52 1.74 0 3.42.31 4.97.86C32.72 15.42 37.2 14 42 14c13.23 0 24 10.77 24 24 0 7.48-3.45 14.16-8.83 18.56l4.26 4.26C67.89 55.31 72 47.13 72 38 72 21.46 58.54 8 42 8ZM0 55v6h6v-7c0-1.58.37-3.08 1.03-4.46C2.89 50.49 0 52.57 0 55Zm6-23c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6ZM0 16.23l15.04 15.04c-.02.24-.04.49-.04.74a9 9 0 0 0 9 9c.25 0 .49-.02.74-.04l8.81 8.81c-2.19-1.68-5.64-2.77-9.54-2.77-6.63 0-12 3.13-12 7v7h24v-7c0-.96-.33-1.87-.93-2.71l6.93 6.93V61h2.77l11 11 4.23-4.23L4.23 12 0 16.23Z",
    style: {
      fill: "currentColor",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMuteAll);
export default __webpack_public_path__ + "static/media/mute_all.ea4cac04a496f19a6af60109e8047d4b.svg";
export { ForwardRef as ReactComponent };